<template>
  <div class="lang-selector">
    <button class="lang-selector__button" ref="triggerRef">
      <span class="lang-selector__icon" :style="selectedIconStyle"></span>
      <span class="lang-selector__drop">
        <span class="lang-selector__lang">{{ selectedLanguage }}</span>
        <svg-icon icon="lh:chevron/down" width="12" height="12"></svg-icon>
      </span>
    </button>
    <tippy :to-element="triggerRef"
           arrow
           arrow-type="round"
           interactive
           animation="fade"
           theme="default defaul-main-menu"
    >
      <ul class="list">
        <li v-for="(langData, code) in supportedLanguages"
            :key="code"
            :class="{'active' : code === selectedLanguage}"
            class="lang-selector__item"
            @click.prevent="onClick(langData.culture)">
          <div class="lang-selector__icon" :style="getIconStyle(langData, code)"></div>
          <div>{{ langData.text }}</div>
<!--          <svg-icon v-if="code === selectedLanguage" class="lang-selector__selected-marker" icon="lh-approved"-->
<!--                    width="12" height="12"></svg-icon>-->
        </li>
      </ul>
    </tippy>
  </div>
</template>

<script>
import SvgIcon from "@/common/controls/SvgIconControl.vue";

export default {
  components: {
    SvgIcon,
  },
  props: {
    selectedLanguage: String,
    supportedLanguages: Object,
  },
  data() {
    return {
      lang: null,
      triggerRef: null,
    };
  },
  mounted() {
    this.triggerRef = this.$refs.triggerRef;
  },
  watch: {
    selectedLanguage: {
      handler() {
        this.lang = this.supportedLanguages[this.selectedLanguage];
      },
      immediate: true,
    },
  },
  computed: {
    selectedIconStyle() {
      return {
        ...this.getIconStyle(this.lang, this.selectedLanguage),
      };
    },
  },
  methods: {
    getIconStyle(lang, code) {
      if(lang) {
        return {
          backgroundImage: `url(${lang.icon})`,
        };  
      }
    },
    
    onClick(culture) {
      this.$emit("update:selected-language", culture);
    },
  },
};
</script>

<style lang="scss" scoped>
.lang-selector {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.list {
  margin: 0;
  padding: 0;
  list-style-type: none;
  cursor: pointer;
}

.lang-selector__button {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  height: 20px;
  font-size: 13px;
  line-height: 20px;
  
  .lang-selector__icon {
    border-radius: 50%;
    width: 16px;
    height: 16px;
  }
}

.lang-selector__icon {
  width: 21px;
  height: 16px;
  border-radius: 0;
  background-size: auto 16px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
}

.lang-selector__drop {
  display: flex;
  flex-flow: row nowrap;
  gap: 8px;
  align-items: center;
  
  > svg {
    color: var(--main-10);
  }
}

.lang-selector__lang {
  color: var(--second-20);
  font-weight: 600;
  line-height: 20px;
}

.lang-selector__item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 8px;
  min-width: 150px;
  padding: 2px 4px;
  border-radius: var(--border-radius-sm);
  user-select: none;
  
  > :nth-child(1) {
    flex: 0 0 auto;
  }
  
  > :nth-child(2) {
    flex: 1 1 100%;
    min-width: 1px;
  }
  
  > svg {
    flex: 0 0 auto;
  }
  
  &.active,
  &:hover {
    background-color: var(--main-10);
    color: var(--white);
  }
}

.lang-selector__selected-marker {
  color: var(--main-30);
}

</style>
